import { Action, ActionFn, defaultActions } from '#/common/components/DataGrid';
import { Finding } from '#/graphql/types';

export const selectedActions: ActionFn<Finding>[] = [
  {
    key: 'delete-findings',
    icon: 'trash',
    text: 'Delete',
  },
];

export const actions: Action<Finding>[] = [...defaultActions];
